// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5a31fc3b","link":"_548f5128","separator":"_ba18a395","sectionWrapper":"_428ad012","section":"_c10d5101","title":"_39045528","copy":"_42b425ad","cta":"_aa9b5fde"};